import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/context/useAuth';
import api from '@/services/axiosConfig';

const ALLOWED_PATHS = ['/test/check-test'];

const CheckTestGuard = () => {
  const { userId } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const { t } = useTranslation();

  const { data: checkTest } = useQuery({
    queryKey: ['checkTest', userId],
    queryFn: async () => {
      if (!userId) return null;
      try {
        const { data } = await api.get(`/quiz/exams/${userId}/check_test`);
        return data;
      } catch {
        return null;
      }
    },
    enabled: !!userId,
    staleTime: 0,
  });

  useEffect(() => {
    if (!checkTest) return;

    const onCheckTestPath = ALLOWED_PATHS.some((path) =>
      location.pathname.startsWith(path),
    );

    if (checkTest.exam_status && onCheckTestPath) {
      navigate('/home', { replace: true });
    } else if (!checkTest.exam_status && !onCheckTestPath) {
      toast({
        title: t('check-test-required', 'Please complete the check test first'),
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      navigate('/test/check-test', { replace: true });
    }
  }, [checkTest, location.pathname, navigate, toast, t]);

  return <Outlet />;
};

export default CheckTestGuard;
